import { gsap } from 'gsap';
import { isElement } from '../utils';
import { scrollPageTo } from '../utils';

import scrollLock from 'scroll-lock';

let fixedEl = null;
let thumbEl = null;
let xTranslation = null;
let singleThumb = null;
let thumbLabels = null;
let breakpoint = window.matchMedia('(max-width:991px)');

function matchesTrigger(el) {
	const selectors = ['[data-event-transition]'];
	return selectors.some((selector) => el.matches(selector));
}

function getThumb(trigger) {
	return trigger.closest('.c-event__thumb');
}

export default {
	name: 'events',
	from: {
		custom: ({ current, next, trigger }) => {
			return isElement(trigger) && matchesTrigger(trigger) && !breakpoint.matches;
		},
	},
	before({ current, next, trigger }) {
		return new Promise((resolve) => {
			// Hide Headerbar
			if (document.body.classList.contains('has-menu-sticky')) {
				document.body.classList.remove('has-scrolled', 'has-menu-sticky');
			}

			scrollLock.disablePageScroll();

			thumbEl = getThumb(trigger);
			thumbEl.parentElement.classList.add('desktop-only');
			let thumbRect = thumbEl.getBoundingClientRect();

			const alignThumbToTop = thumbRect.top + window.scrollY - 141; // 141 = offset on single
			scrollPageTo(alignThumbToTop, 800).then(() => {
				let thumbRect = thumbEl.getBoundingClientRect();

				xTranslation = thumbRect.right - window.innerWidth * 0.4;

				fixedEl = document.createElement('div');
				fixedEl.classList.add('event-transition-fixed-container');

				gsap.set(fixedEl, {
					width: thumbRect.width,
					height: thumbRect.height,
					left: thumbRect.left,
					top: thumbRect.top,
				});

				gsap.set(thumbEl.parentElement, {
					width: thumbRect.width,
					height: thumbRect.height,
				});

				document.body.appendChild(fixedEl);
				fixedEl.appendChild(thumbEl);

				resolve();
			});
		});
	},
	leave({ current, next, trigger }) {
		return new Promise((resolve) => {
			resolve();
		});
	},
	afterLeave({ current, next, trigger }) {
		return new Promise((resolve) => {
			singleThumb = next.container.querySelector('[data-single-event-thumb]');
			singleThumb.innerHTML = '';

			gsap.set(current.container, {
				position: 'absolute',
				top: window.scrollY * -1,
				left: 0,
				width: '100%',
			});

			gsap.set(next.container, {
				opacity: 0,
			});

			window.scrollTo(0, 0);

			resolve();
		});
	},
	beforeEnter({ current, next, trigger }) {
		return new Promise((resolve) => {
			const singleContent = next.container.querySelector('[data-single-event-content]');
			singleContent.style.transform = 'translateX(' + xTranslation + 'px)';
			const eventCards = current.container.querySelectorAll('.c-event-card');

			gsap.to(eventCards, {
				opacity: 0,
				x: xTranslation * -1,
				ease: 'power4.inOut',
				duration: 1.2,
			});

			gsap.to(current.container, {
				opacity: 0,
				ease: 'none',
				duration: 1.2,
			});

			gsap.to(fixedEl, {
				x: xTranslation * -1,
				ease: 'power4.inOut',
				duration: 1.2,
			});

			thumbLabels = thumbEl.querySelector('[data-event-thumb-labels]');
			const labelTranslation = thumbEl.getBoundingClientRect().width - 28 - thumbLabels.getBoundingClientRect().width;
			if (thumbLabels) {
				gsap.to(thumbLabels, {
					x: labelTranslation,
					ease: 'power4.inOut',
					duration: 1.2,
				});
			}

			// Hide & disable details button
			trigger.style.pointerEvents = 'none';
			if (trigger.getAttribute('data-event-transition-by-image-click') != null) {
				const button = trigger.closest('.c-event__thumb').querySelector('[data-event-transition-by-button-click]');
				gsap.set(button, {
					pointerEvents: 'none',
				});

				gsap.to(button, {
					opacity: 0,
					ease: 'none',
					duration: 0.4,
				});
			} else {
				const image = trigger.closest('.c-event__thumb').querySelector('[data-event-transition-by-image-click]');
				gsap.set(image, {
					pointerEvents: 'none',
				});

				gsap.to(trigger, {
					opacity: 0,
					ease: 'none',
					duration: 1.2,
				});
			}

			gsap.to(next.container, {
				opacity: 1,
				ease: 'none',
				duration: 1.2,
			});

			gsap.to(singleContent, {
				x: 0,
				ease: 'power4.inOut',
				duration: 1.2,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
	enter({ current, next, trigger }) {
		return new Promise((resolve) => {
			const fixedThumb = fixedEl.querySelector('.c-event__thumb');
			singleThumb.appendChild(fixedThumb);
			thumbLabels.style.transform = '';

			fixedEl.remove();

			scrollLock.enablePageScroll();

			resolve();
		});
	},
};
